<template>
  <div class="content-area">
    <hero-bar>
      {{ $t('createDepartment') }}
      <b-button
        slot="right"
        icon-left="content-save-off"
        type="is-warning"
        class="mr-3"
        tag="router-link"
        :to="{ name: 'departments.index' }"
      >
        {{ $t('cancel') }}
      </b-button>
      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{ 'is-loading': isLoading }"
        @click="submit"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>

    <form ref="form" @submit.prevent="submit">
      <section class="section is-main-section">
        <card-component :title="$t('departmentInfo')" icon="code-greater-than-or-equal">
          <div class="columns">
            <div class="column">
              <b-field>
                <b-input
                  v-model="form.name"
                  type="text"
                  :placeholder="$t('departmentName') + ' *'"
                  validation-message="Departman adı zorunlu."
                  required
                />
              </b-field>
            </div>
            <div class="column">
              <b-field class="mt-2">
                <b-switch v-model="form.is_active" :value="true">
                  {{ form.is_active ? 'Aktif' : 'Pasif' }}
                </b-switch>
              </b-field>
            </div>
          </div>
        </card-component>
      </section>
    </form>
  </div>
</template>
<script>
import 'cleave.js/dist/addons/cleave-phone.tr'
import { mapState } from 'vuex'

export default {
  title: ({ $i18n }) => $i18n.t('createDepartment'),
  components: {
    CardComponent: () => import('@/components/CardComponent'),
    HeroBar: () => import('@/components/HeroBar'),
  },
  data () {
    return {
      isLoading: false,
      form: {
        name: '',
        is_active: true,
      },
    }
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  created () {
    this.$store.commit('setAsideActiveMenuKey', 'departments.index')
  },
  mounted () {
    //
  },
  methods: {
    submit () {
      if (!this.validateFormData(this.form)) {
        this.$buefy.toast.open({
          message: this.$t('checkFormValidation'),
          type: 'is-warning',
          duration: 5000,
        })

        return false
      }

      this.isLoading = true

      this.$http
        .post('departments', this.form)
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            this.$buefy.toast.open({
              message: this.$t('departmentCreated'),
              type: 'is-success',
              duration: 5000,
            })

            this.$router.push('/departments')
          }
        }).catch(e => {
          const errors = this.$_.flattenDeep(this.$_.values(e.response.data.error.errors)).join('<br>');
            this.$buefy.toast.open({
              message: this.$t('error') + ': <br>' + errors,
              type: 'is-warning',
              duration: 5000,
            })

            this.isLoading = false
        })
    },
    validateFormData (data) {
      return data.name && (data.is_active === true || data.is_active === false)
    },
    focusInput (e) {
      this.$nextTick()
        .then(() => {
          const vals = e.target.value
          e.target.value = ''
          e.target.value = vals
      })
    }
  }
}
</script>